module.exports = __webpack_public_path__ + "static/img/20200423.bf3efd9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/20200423.jpg
// module id = SMtD
// module chunks = 98